__turbopack_context__.v({
  "allGood": "BenefitRadar-module__WE9fjq__allGood",
  "caveat": "BenefitRadar-module__WE9fjq__caveat",
  "desc": "BenefitRadar-module__WE9fjq__desc",
  "disclaimer": "BenefitRadar-module__WE9fjq__disclaimer",
  "head": "BenefitRadar-module__WE9fjq__head",
  "icon": "BenefitRadar-module__WE9fjq__icon",
  "title": "BenefitRadar-module__WE9fjq__title",
});
